import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import type { ActionTemplate } from 'config/api/actionLibrary/actionLibrary.types';
import action_library_messages from 'messages/action_library_messages';

import useStyles from './ActionTemplateSummaryPopoverContent.styles';

const getCleanDescription = (htmlContent: string): string => htmlContent.replace(/<[^>]+>/g, '').trim();

type Props = {
  template: ActionTemplate;
};

/**
 * Reusable summary content for Action Template (e.g. table row popover).
 * Shows: shortDescription (2 lines), Created at, Updated at, instances count, steps number.
 */
const ActionTemplateSummaryPopoverContent: React.FC<Props> = ({ template }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const shortDescription = template.shortDescription ? getCleanDescription(template.shortDescription) : '';
  const createdAt = template.createdAt ? format(new Date(template.createdAt), 'yyyy-MM-dd HH:mm') : '-';
  const updatedAt = template.updatedAt ? format(new Date(template.updatedAt), 'yyyy-MM-dd HH:mm') : '-';
  const instancesCount = template.instancesCountAllOrgs ?? '-';
  const stepsCount = template.steps?.length ?? 0;

  return (
    <Box className={styles.root}>
      <Typography className={styles.descriptionLabel} component='div' display='block' variant='caption'>
        <strong>{t(action_library_messages.detail.description)}:</strong>
      </Typography>
      <Typography className={styles.descriptionContent} component='div' variant='caption'>
        {shortDescription || '-'}
      </Typography>
      <Typography component='div' display='block' variant='caption'>
        <strong>{t(action_library_messages.detail.created_at)}:</strong> {createdAt}
      </Typography>
      <Typography component='div' display='block' variant='caption'>
        <strong>{t(action_library_messages.detail.updated_at)}:</strong> {updatedAt}
      </Typography>
      <Typography component='div' display='block' variant='caption'>
        <strong>{t(action_library_messages.table.popover_instances_count)}:</strong> {instancesCount}
      </Typography>
      <Typography component='div' display='block' variant='caption'>
        <strong>{t(action_library_messages.table.number_of_steps)}:</strong> {stepsCount}
      </Typography>
    </Box>
  );
};

export default ActionTemplateSummaryPopoverContent;
